class CompareUtils {
  static cookieName = 'kiktheme:compare-products';

  static getSelectedProducts() {
    const products = KikTheme.util.storage.get(this.cookieName);
    return products || [];
  }

  static setSelectedProducts(products) {
    if (products.length > 0) {
      KikTheme.util.storage.set(this.cookieName, products);
    } else {
      localStorage.removeItem(this.cookieName);
    }
  }

  static getProductsCount() {
    return this.getSelectedProducts().length;
  }


  static isProductInList(productId) {
    const products = this.getSelectedProducts();

    return products.find((product) => product.id === productId);
  }

  static addToList(productId, productUrl) {
    let products = KikTheme.util.storage.get(this.cookieName) || [];

    if (products.length < KikTheme.config.compareProduct.max) {
      if (!products.some((product) => product.id === productId)) {
        products.push({ id: productId, url: productUrl });
      }

      this.setSelectedProducts(products);
      this.updateCompareCheckboxes(products);

      KikTheme.pubsub.publish(KikTheme.pubsub.PUB_SUB_EVENTS.compare.add, { products: products, productId: productId, productUrl: productUrl });

      return true;
    } else {
      alert(KikTheme.config.compareProduct.alertMessage);

      return false;
    }
  }

  static removeFromList(productId) {
    let products = this.getSelectedProducts();
    if (products) {
      products = products.filter((product) => product.id !== productId);
    }
    this.setSelectedProducts(products);
    this.updateCompareCheckboxes(products);
    KikTheme.pubsub.publish(KikTheme.pubsub.PUB_SUB_EVENTS.compare.remove, { products: products, productId: productId });
  }

  static clearList() {
    const products = this.getSelectedProducts();
    if (products) {
      products.forEach((product) => {
        this.removeFromList(product.id);
      });
    }
  }

  static updateCompareCheckboxes(products = null) {
    products = products || this.getSelectedProducts();
    document.querySelectorAll('.js-kik-compare-checkbox').forEach((checkbox) => {
      checkbox.checked = products.filter((product) => product.id === checkbox.dataset.productId).length;
      if(!checkbox.checked) {checkbox.disabled = this.getProductsCount() > 2};
    });
  }

  static getTemplateUrl(productUrl, queryObj = {}) {
    let url = productUrl;
    const separator = productUrl.includes('?') ? '&' : '?';
    const params = new URLSearchParams();

    for (const key in queryObj) {
      if (Object.prototype.hasOwnProperty.call(queryObj, key)) {
        params.append(key, queryObj[key]);
      }
    }

    // Append parameters to the URL if any were added.
    if (Array.from(params).length > 0) {
      url += `${separator}${params.toString()}`;
    }

    return url;
  }

  static getKikCompareBarItemTemplate(productUrl) {
    return this.getTemplateUrl(productUrl, {
      sections: 'product-compare-bar-item',
    });
  }
}

class KikCompareSwitch extends HTMLElement {
  constructor() {
    super();

    this.cookieName = 'kiktheme:compare-is-active';

    this.classes = {
      isActive: 'is-product-comparing',
    };

    this.checkboxEl = this.querySelector('input');
    this.onChangeHandler = this.onChange.bind(this);
  }

  connectedCallback() {
    this.init();
    this.checkboxEl.addEventListener('change', this.onChangeHandler);
    CompareUtils.updateCompareCheckboxes();
  }

  disconnectedCallback() {
    this.checkboxEl.removeEventListener('change', this.onChangeHandler);
  }

  init() {
    if (KikTheme.config.hasLocalStorage) {
      const isActive = window.localStorage.getItem(this.cookieName) === 'true';
      if (isActive) {
        this.checkboxEl.checked = isActive;
        this.handleChange(isActive);
      }
    }
  }

  onChange(evt) {
    evt.preventDefault();

    this.handleChange(this.checkboxEl.checked);
  }

  handleChange(isActive) {
    requestAnimationFrame(() => {
      if (isActive) {
        document.body.classList.add(this.classes.isActive);
      } else {
        document.body.classList.remove(this.classes.isActive);
      }
    });

    KikTheme.pubsub.publish(KikTheme.pubsub.PUB_SUB_EVENTS.compare.toggle, { isActive: isActive });

    if (KikTheme.config.hasLocalStorage) {
      window.localStorage.setItem(this.cookieName, isActive);
    }
  }
}
customElements.define('kik-compare-switch', KikCompareSwitch);

class KikCompareCheckbox extends HTMLElement {
  constructor() {
    super();

    this.checkboxEl = this.querySelector('input');
    this.onChangeHandler = this.onChange.bind(this);

    this.classes = {
      isActive: 'is-product-comparing',
    };
  }

  connectedCallback() {
    this.init();
    this.checkboxEl.addEventListener('change', this.onChangeHandler);
  }

  disconnectedCallback() {
    this.checkboxEl.removeEventListener('change', this.onChangeHandler);
  }

  init() {
    const { productId } = this.checkboxEl.dataset;
    this.checkboxEl.checked = CompareUtils.isProductInList(productId);

    const products = CompareUtils.getSelectedProducts();
    this.updateStatus(products.length);
  }

  onChange(evt) {
    evt.preventDefault();
    const { productId, productUrl } = this.checkboxEl.dataset;

    if (this.checkboxEl.checked) {
      const isAdded = CompareUtils.addToList(productId, productUrl);
      if (!isAdded) {
        this.checkboxEl.checked = false;
      }
    } else {
      CompareUtils.removeFromList(productId);
    }

    const products = CompareUtils.getSelectedProducts();
    this.updateStatus(products.length);
  }

  // Added as per design new request
  updateStatus(count) {
    const isActive = count > 0;

    requestAnimationFrame(() => {
      if (isActive) {
        document.body.classList.add(this.classes.isActive);
      } else {
        document.body.classList.remove(this.classes.isActive);
      }
    });
    
    const kikCompareSwitches = document.querySelectorAll('kik-compare-switch');

    if (kikCompareSwitches) {
      kikCompareSwitches.forEach(kikCompareSwitch => {
        kikCompareSwitch.checkboxEl.checked = isActive;
        kikCompareSwitch.handleChange(isActive);
      });
    }

    KikTheme.pubsub.publish(KikTheme.pubsub.PUB_SUB_EVENTS.compare.toggle, { isActive: isActive });

    if (KikTheme.config.hasLocalStorage) {
      window.localStorage.setItem(this.cookieName, isActive);
    }
  }
}
customElements.define('kik-compare-checkbox', KikCompareCheckbox);

class KikCompareRemove extends HTMLElement {
  constructor() {
    super();

    this.onClickHandler = this.onClick.bind(this);
    this.addEventListener('click', this.onClick.bind(this));

    this.classes = {
      isActive: 'is-product-comparing',
    };
  }

  onClick(event) {
    event.preventDefault();

    const { productId } = this.dataset;
    const { target } = event;

    CompareUtils.removeFromList(productId);

    const compareModal = target.closest('kik-compare-modal');
    if (compareModal) {
      compareModal.updateProductsCount();
    }

    if (CompareUtils.getProductsCount() < 1) {
      compareModal && compareModal.hide();
    } else {
      const compareTable = target.closest('.compare-table');
      if (compareTable) {
        const cell = target.closest('td');
        const colIndex = cell.cellIndex;

        const rows = compareTable.querySelectorAll('tr');
        rows.forEach((row) => {
          const cellToRemove = row.cells[colIndex];
          if (cellToRemove) {
            cellToRemove.remove();
          }
        });
      }
    }

    const products = CompareUtils.getSelectedProducts();
    this.updateStatus(products.length);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClickHandler);
  }

  // Added as per design new request
  updateStatus(count) {
    const isActive = count > 0;

    requestAnimationFrame(() => {
      if (isActive) {
        document.body.classList.add(this.classes.isActive);
      } else {
        document.body.classList.remove(this.classes.isActive);
      }
    });
    
    const kikCompareSwitches = document.querySelectorAll('kik-compare-switch');

    if (kikCompareSwitches) {
      kikCompareSwitches.forEach(kikCompareSwitch => {
        kikCompareSwitch.checkboxEl.checked = isActive;
        kikCompareSwitch.handleChange(isActive);
      });
    }

    KikTheme.pubsub.publish(KikTheme.pubsub.PUB_SUB_EVENTS.compare.toggle, { isActive: isActive });

    if (KikTheme.config.hasLocalStorage) {
      window.localStorage.setItem(this.cookieName, isActive);
    }
  }
}
customElements.define('kik-compare-remove', KikCompareRemove);


class KikCompareBar extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      openBtn: '.compare-bar__open',
      clearBtns: ['.compare-bar__clear'],
      toggleList: '.compare-bar__toggle-list',
      list: '.compare-bar__list',
      counter: '.compare-bar__counter',
    };

    this.classes = {
      listVisible: 'is-show-list',
      isActive: 'is-product-comparing'
    };

    this.abortController = new AbortController();
    this.elements = KikTheme.util.queryDomNodes(this.selectors, this);
    this.atLeastItemToShow = Math.min(3, KikTheme.config.compareProduct.max); // Total compare products and placeholders.

    this.elements.clearBtns.forEach((clearBtn) => {
      clearBtn.addEventListener('click', this.handleClear.bind(this), {
        signal: this.abortController.signal,
      });
    });

    this.elements.toggleList.addEventListener('click', this.handleToggleList.bind(this), {
      signal: this.abortController.signal,
    });

    
    this.itemAddUnsubscriber = KikTheme.pubsub.subscribe(KikTheme.pubsub.PUB_SUB_EVENTS.compare.add, this.onItemAdded.bind(this));
    this.itemRemoveUnsubscriber = KikTheme.pubsub.subscribe(KikTheme.pubsub.PUB_SUB_EVENTS.compare.remove, this.onItemRemoved.bind(this));
  }

  itemAddUnsubscriber = undefined;
  itemRemoveUnsubscriber = undefined;

  connectedCallback() {
    this.renderBar();
    const mql = window.matchMedia(KikTheme.config.mediaQueryMobile);
    mql.onchange = this.setHeight.bind(this);
    this.setHeight();
  }

  disconnectedCallback() {
    this.abortController.abort();

    if (this.itemAddUnsubscriber) {
      this.itemAddUnsubscriber();
    }

    if (this.itemRemoveUnsubscriber) {
      this.itemRemoveUnsubscriber();
    }
  }

  onItemAdded(event) {
    const { products, productId, productUrl } = event;

    this.appendBarItem(products, productId, productUrl);
    this.toggleCompareButton(products.length);
    this.updateCounters(products.length);
  }

  onItemRemoved(event) {
    const { products, productId } = event;
    const itemToDelete = this.elements.list.querySelector(`.compare-bar__item[data-product-id="${productId}"]`);

    itemToDelete && itemToDelete.remove();
    this.toggleCompareButton(products.length);
    this.updateCounters(products.length);
    this.removePlaceholdes();
    this.addPlaceholders(products.length);
  }

  async renderBar() {
    const products = CompareUtils.getSelectedProducts();

    let output = '';
    const compareItemHtmls = await this.getBarItems(products);
    compareItemHtmls.forEach((htmlStr) => {
      output += htmlStr;
    });

    this.removePlaceholdes();
    this.elements.list.innerHTML = output;
    this.addPlaceholders(products.length);

    this.toggleCompareButton(products.length);
    this.updateCounters(products.length);
  }

  async getBarItems(products) {
    const tmps = [];
    await Promise.all(
      products.map(async (product) => {
        const fetchUrl = CompareUtils.getKikCompareBarItemTemplate(product.url);
        await fetch(CompareUtils.getKikCompareBarItemTemplate(product.url))
          .then((response) => response.json())
          .then((response) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(response['product-compare-bar-item'], 'text/html');
            const itemHtml = doc.querySelector('.shopify-section');

            tmps[product.id] = itemHtml.innerHTML;
          });
      })
    );

    const returns = [];
    products.forEach((product) => returns.push(tmps[product.id]));
    return returns;
  }

  async appendBarItem(products, productId, productUrl) {
    this.removePlaceholdes();
    this.elements.list.insertAdjacentHTML(
      'beforeend',
      `<li class="compare-bar__item" data-product-id="${productId}"></li>`
    );
    this.addPlaceholders(products.length);

    await fetch(CompareUtils.getKikCompareBarItemTemplate(productUrl))
      .then((response) => response.json())
      .then((response) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(response['product-compare-bar-item'], 'text/html');
        const itemHtml = doc.querySelector('.shopify-section');

        const itemEl = this.elements.list.querySelector('[data-product-id="' + productId + '"]');
        if (itemEl) {
          itemEl.outerHTML = itemHtml.innerHTML;
        }
      });
  }

  handleToggleList(event) {
    event.preventDefault();

    if (this.classList.contains(this.classes.listVisible)) {
      this.classList.remove(this.classes.listVisible);
    } else {
      this.classList.add(this.classes.listVisible);
    }

    this.setHeight();
  }

  handleClear() {
    CompareUtils.clearList();
    const products = CompareUtils.getSelectedProducts();
    this.updateStatus(products.length);
  }

  toggleCompareButton(count) {
    this.elements.openBtn.disabled = !(count > 1);
  }

  updateCounters(count) {
    this.elements.counter.innerText = count;
  }

  removePlaceholdes() {
    Array.from(this.elements.list.querySelectorAll('li')).forEach((li) => {
      if (li.classList.contains('compare-bar__item-placeholder')) {
        li.remove();
      }
    });
  }

  addPlaceholders(count) {
    const placeholderCount = this.atLeastItemToShow - count;

    for (let i = 0; i < placeholderCount; i++) {
      const placeholderItem = document.createElement('li');

      placeholderItem.classList.add('compare-bar__item', 'compare-bar__item-placeholder');
      this.elements.list.appendChild(placeholderItem);
    }
  }

  setHeight() {
    requestAnimationFrame(() => {
      const offsetHeight = Math.round(this.offsetHeight);
      document.documentElement.style.setProperty('--compare-bar-height', `${offsetHeight}px`);
    });
  }

  // Added as per design new request
  updateStatus(count) {
    const isActive = count > 0;

    console.log(isActive, count);

    requestAnimationFrame(() => {
      if (isActive) {
        document.body.classList.add(this.classes.isActive);
      } else {
        document.body.classList.remove(this.classes.isActive);
      }
    });
    
    const kikCompareSwitches = document.querySelectorAll('kik-compare-switch');

    if (kikCompareSwitches) {
      kikCompareSwitches.forEach(kikCompareSwitch => {
        kikCompareSwitch.checkboxEl.checked = isActive;
        kikCompareSwitch.handleChange(isActive);
      });
    }

    KikTheme.pubsub.publish(KikTheme.pubsub.PUB_SUB_EVENTS.compare.toggle, { isActive: isActive });

    if (KikTheme.config.hasLocalStorage) {
      window.localStorage.setItem(this.cookieName, isActive);
    }
  }
}
customElements.define('kik-compare-bar', KikCompareBar);

class KikModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="kikModalClose-"]').addEventListener('click', this.hide.bind(this, false));
        
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });

        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            });
        }else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
        }
    }
    
    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }
    
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      // document.documentElement.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      KikTheme.util.trapFocus(this, this.querySelector('[role="dialog"]'));
      KikTheme.util.pauseAllMedia();
    }
    
    hide() {
        document.body.classList.remove('overflow-hidden');
        // document.documentElement.classList.remove('overflow-hidden');
        document.documentElement.dispatchEvent(new CustomEvent('kik-modal:closed'));
        this.removeAttribute('open');
        KikTheme.util.removeTrapFocus(this.openedBy);
        KikTheme.util.pauseAllMedia();
    }
}
customElements.define('kik-modal-dialog', KikModalDialog);

class KikModalOpener extends HTMLElement {
  constructor() {
      super();
  
      const button = this.querySelector('button') || this.querySelector('.kik-modal-opener-button');
  
      if (!button) return;
          button.addEventListener('click', (e) => {
              e.preventDefault();
              const modal = document.querySelector(this.getAttribute('data-modal'));
              if (modal) modal.show(button);
      });
  }
}
customElements.define('kik-modal-opener', KikModalOpener);

if (!customElements.get('kik-compare-modal')) {
  customElements.define(
    'kik-compare-modal',
    class KikCompareModalDialog extends KikModalDialog {
      constructor() {
        super();

        this.selectors = {
          table: '.compare-table',
        };

        this.classesToRemoveOnLoad = 'drawer--loading';

      }

      get selector() {
        return '.product-comparison-table';
      }

      get sourceSelector() {
        return '#MainProduct-compare__rows';
      }

      getSectionId() {
        let sectionId = KikTheme.ProductCompareSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const sectionEl = document.querySelector('.section-kik-product-compare-modal');
          if (sectionEl) {
            sectionId = KikTheme.util.getSectionId(sectionEl);
          }

          // Cache for better performance.
          KikTheme.ProductCompareSectionId = sectionId;
        }

        return sectionId;
      }

      show(opener) {
        super.show(opener);
        this.renderCompareTable();
      }

      hide() {
        super.hide();
        this.handleAfterHide();
      }

      updateProductsCount(count) {
        this.style.setProperty('--number-items', count || CompareUtils.getProductsCount());
      }

      async renderCompareTable() {
        const products = CompareUtils.getSelectedProducts();

        this.updateProductsCount();

        this.elements = KikTheme.util.queryDomNodes(this.selectors, this);
        const tableRows = this.elements.table.querySelectorAll('tbody tr');
        let compareRows = await this.getCompareTableRows(products);

        compareRows.forEach((compareRow) => {
          tableRows.forEach((row) => {
            const compareKey = row.dataset.compareKey;
            const compareCol = compareRow.querySelector(`td[data-compare-key="${compareKey}"]`);
            if (compareCol) {
              row.appendChild(compareCol);
            }
          });
        });

        setTimeout(() => {
          this.classList.remove(this.classesToRemoveOnLoad);
        }, 300);
      }

      async getCompareTableRows(products) {
        const tmps = [];
        const sectionId = this.getSectionId();
        // const sectionId = 'popup-compare';

        await Promise.all(
          products.map(async (product) => {
            const fetchUrl = CompareUtils.getTemplateUrl(product.url, {
              section_id: sectionId,
            });
            await fetch(fetchUrl)
              .then((response) => response.text())
              .then((responseText) => {
                const rowTemplate = new DOMParser()
                  .parseFromString(responseText, 'text/html')
                  .querySelector(this.sourceSelector);

                if (rowTemplate) {
                  tmps[product.id] = rowTemplate.content.cloneNode(true);
                }
              });
          })
        );

        const returns = [];
        products.forEach((product) => {
          if (tmps[product.id]) {
            returns.push(tmps[product.id]);
          }
        });
        return returns;
      };

      handleAfterHide() {
        this.querySelectorAll(`${this.selectors.table} > tbody > tr`).forEach((row) => {
          const nonLabelCells = row.querySelectorAll('td:not(.td-label)');
          nonLabelCells.forEach((cell) => {
            cell.remove();
          });
        });

        this.classList.add(this.classesToRemoveOnLoad);
      };
    }
  );
}